// components/organisms/Footer/Footer.js
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Icon from '../../Atoms/Icon/Icon';

const FooterLink = ({ label, url, icon }) => {
    const isExternal = url.startsWith('http');
    const linkProps = isExternal
        ? { target: '_blank', rel: 'noopener noreferrer' }
        : {};

    return (
        <Link href={url} className="footer-link cluster cluster-tight" {...linkProps}>
            {icon && <Icon name={icon} size="sm" decorative />}
            <span>{label}</span>
        </Link>
    );
};

const Footer = ({ footerPages = [], copyright = '', className = '' }) => {
    return (
        <footer className={className ? `footer ${className}` : 'footer'}>
            <div className="footer-container">
                <div className="footer-grid">
                    {footerPages.map((column, index) => (
                        <div key={index} className="footer-section">
                            {column.heading && (
                                <span className="footer-section-title">{column.heading}</span>
                            )}
                            <nav className="footer-links">
                                {column.links?.map((link, i) => (
                                    <FooterLink key={i} {...link} />
                                ))}
                            </nav>
                        </div>
                    ))}
                </div>
                {copyright && (
                    <div className="mt-md text-left">
                        <span className="text-label footer-link">{copyright}</span>
                    </div>
                )}
            </div>
        </footer>
    );
};

Footer.propTypes = {
    footerPages: PropTypes.arrayOf(
        PropTypes.shape({
            heading: PropTypes.string,
            links: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    url:   PropTypes.string.isRequired,
                    icon:  PropTypes.string,
                })
            ),
        })
    ),
    copyright: PropTypes.string,
    className: PropTypes.string,
};

export default Footer;